import { ProfileRealEstateType } from '.';

export interface DealFinancialMetric {
	guid: string;
	dealGuid: string;
	analysisMetricType?: DealAnalysisMetricType;
	financialMetricType?: DealFinancialMetricType;
	metricName: string;
	twoYearsAgo?: number;
	previousFullYear?: number;
	trailingTwelveMonths?: number;
	projectedFullYear?: number;
	futureYear?: number;
	amountDescription?: string;
	profileRealEstateType?: ProfileRealEstateType;
}

export type DealFinancialMetricType = keyof typeof DealFinancialMetricTypeMap;

export const DealFinancialMetricTypeMap = {
	Cash: 'Cash & Marketables',
	AccountsReceivables: 'Accounts Receivable',
	Inventory: 'Inventory',
	RealEstate: 'Owner Occupied Real Estate',
	FurnitureFixture: 'Furniture / Fixtures',
	Equipment: 'Machinery & Equipment',
	Vehicles: 'Rolling Stock/Vehicles',
	MarineVessels: 'Marine Vessels',
	Helicopters: 'Helicopters',
	FixedWingAircraft: 'Fixed Wing Aircraft',
	Royalties: 'Royalty/Licensing Agreements',
	IntellectualProperty: 'Intellectual Property',
	TotalRevenue: 'Total Revenue',
	NetIncome: 'Net Income',
	Ebitda: 'EBITDA',
	Adjustments: 'EBITDA Adjustments',
	AdjustedEbitda: 'Adjusted EBITDA',
	Mrr: 'MRR',
};

export type DealAnalysisMetricType = keyof typeof DealAnalysisMetricTypeMap;

export const DealAnalysisMetricTypeMap = {
	Borrower: 'Borrower',
	Acquisition: 'Acquisition',
};

export const isIncomeMetricType = (metric: DealFinancialMetric): boolean => {
	return (
		metric.financialMetricType === 'TotalRevenue' ||
		metric.financialMetricType === 'NetIncome' ||
		metric.financialMetricType === 'Ebitda' ||
		metric.financialMetricType === 'Adjustments' ||
		metric.financialMetricType === 'AdjustedEbitda' ||
		metric.financialMetricType === 'Mrr'
	);
};

export const isBalanceSheetMetricType = (metric: DealFinancialMetric): boolean => {
	return !isIncomeMetricType(metric);
};
